<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to previous page" @click="backToPrev">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer> 
                    <help-link appId="projects" pageId="project-charges-weekly" color="white"></help-link>
                    <v-menu v-if="!loading&&hasEditAndApprover" left v-model="menu_status" offset-y :disabled="disabledForEditAndApprover">  
                        <template v-slot:activator="{ on }">    
                            <div v-if="noData||createdAllStatus||forReviewAllStatus||approvedAllStatus||rejectedAllStatus">
                                <v-btn v-show="noData" v-on="on" :loading="loading_menu">
                                    &nbsp;&nbsp;Add Task&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                                <v-btn v-show="createdAllStatus" v-on="on" :loading="loading_menu">
                                    &nbsp;&nbsp;Created&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                                <v-btn v-show="forReviewAllStatus" v-on="on" color="orange" dark :loading="loading_menu">
                                    &nbsp;&nbsp;For Review&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                                <v-btn v-show="approvedAllStatus" color="green darken-2" dark v-on="on" :loading="loading_menu">
                                    &nbsp;&nbsp;Approved&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                                <v-btn v-show="rejectedAllStatus" color="red" dark v-on="on" :loading="loading_menu">
                                    &nbsp;&nbsp;Rejected&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                            </div>   
                            <div v-else>
                                <v-btn v-on="on" :loading="loading_menu" dark color="orange">
                                    &nbsp;&nbsp;Under Revision&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                            </div>
                        </template>
                        <v-list dense>
                            <v-list-tile v-show="hasEditAndApprover&&!forReviewAllStatus&&!approvedAllStatus" :key="0" @click="showAddProject" title="Add Project">
                                <v-list-tile-title small>Add Task</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasHoursEntered&&hasEditAndApprover&&!forReviewAllStatus&&!approvedAllStatus" :key="1" @click="saveAll" title="Save all">
                                <v-list-tile-title small>Save</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasHoursEntered&&hasEditAndApprover&&!forReviewAllStatus&&!approvedAllStatus" :key="2" @click="submitAll" title="Save and set For Review">
                                <v-list-tile-title small>For Review</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasEditAndApprover&&(forReviewAllStatus||rejectedAllStatus)" :key="0" @click="approveAll" title="Approve all">
                                <v-list-tile-title small>Approve</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasEditAndApprover&&(forReviewAllStatus||approvedAllStatus)" :key="1" @click="rejectAll" title="Reject all">
                                <v-list-tile-title small>Reject</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                    <v-menu v-if="!loading&&!hasEditAndApprover" left v-model="menu_status" offset-y :disabled="disableForOwner||disabledForApprover">  
                        <template v-slot:activator="{ on }"> 
                            <div v-if="noData||createdAllStatus||forReviewAllStatus||approvedAllStatus||rejectedAllStatus">
                                <v-btn v-show="noData" v-on="on" :loading="loading_menu">
                                    &nbsp;&nbsp;Add Task&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                                <v-btn v-show="createdAllStatus" v-on="on" :loading="loading_menu">
                                    &nbsp;&nbsp;Created&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                                <v-btn v-show="forReviewAllStatus" v-on="on" color="orange" dark :loading="loading_menu">
                                    &nbsp;&nbsp;For Review&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                                <v-btn v-show="approvedAllStatus" color="green darken-2" dark v-on="on" :loading="loading_menu">
                                    &nbsp;&nbsp;Approved&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                                <v-btn v-show="rejectedAllStatus" color="red" dark v-on="on" :loading="loading_menu">
                                    &nbsp;&nbsp;Rejected&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                            </div>   
                            <div v-else>
                                <v-btn v-on="on" :loading="loading_menu" dark color="orange">
                                    &nbsp;&nbsp;Under Revision&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                            </div>
                        </template>
                        <v-list dense>
                            <v-list-tile v-show="!lockedPeriod&&hasEditRights" :key="0" @click="showAddProject" title="Add Project">
                                <v-list-tile-title small>Add Task</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="!lockedPeriod&&hasHoursEntered&&hasEditRights" :key="1" @click="saveAll" title="Save all">
                                <v-list-tile-title small>Save</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="!lockedPeriod&&hasHoursEntered&&hasEditRights" :key="2" @click="submitAll" title="Save and set For Review">
                                <v-list-tile-title small>For Review</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="!lockedPeriod&&hasApproverRights&&(forReviewAllStatus||rejectedAllStatus)" :key="0" @click="approveAll" title="Approve all">
                                <v-list-tile-title small>Approve</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="!lockedPeriod&&hasApproverRights&&(forReviewAllStatus||approvedAllStatus)" :key="1" @click="rejectAll" title="Reject all">
                                <v-list-tile-title small>Reject</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate color="primary" height="3" style="margin:1px -3px 0px -3px;"></v-progress-linear>
            </v-card>
            
            <!-- REGULAR CHARGES -->
            <v-card v-if="!loading" class="elavation-1" style="margin-top:5px;"> 
               <v-toolbar flat height="40px">
                    <v-chip v-if="!loading&&!viewedByOwner" style="margin-left:-5px;">
                        <v-avatar>
                            <v-img ref="avatar" :src="user_data.avatar"></v-img>
                        </v-avatar>
                        {{user_data.firstName}} {{user_data.lastName}}
                    </v-chip> 
                    <b>PROJECT CHARGES</b>
                    <v-spacer></v-spacer>
                    <v-btn icon small title="View previous week"  @click="viewPrevious" style="margin-right:10px;" :disabled="loading||disablePrev">
                        <v-icon>chevron_left</v-icon>
                    </v-btn>
                    <b>{{weekCoverageDesc.from}} to {{weekCoverageDesc.to}}</b>
                    <v-btn icon small title="View next week" @click="viewNext" :disabled="loading||disableNext">
                        <v-icon>chevron_right</v-icon>
                    </v-btn>  
                </v-toolbar>
                <v-data-table
                    :headers="tableHeader"
                    :items="task.summary"
                    :loading="loading"
                    hide-actions
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr>
                            <td>
                                <span v-if="props.item.isAdminProject">[<b>{{props.item.taskCode}}</b>] {{props.item.taskDescription}}</span>
                                <span v-else :title="`Project: ${props.item.projectCode} - ${props.item.projectName}`">[<b>{{props.item.client}}</b>] {{props.item.taskCode}} - {{props.item.taskDescription}}</span>                                
                            </td>
                            <td>
                                <span v-if="!isEditable(1)||disabledInputText">{{getChargesHours('Task',props.item, 1)}}</span>
                                <v-text-field v-else v-model="getHoursModel(props.item).day1" type="number" @blur="formatHours" class="input-text"></v-text-field>
                            </td>
                            <td>
                                <span v-if="!isEditable(2)||disabledInputText">{{getChargesHours('Task',props.item, 2)}}</span>
                                <v-text-field v-else v-model="getHoursModel(props.item).day2" type="number" @blur="formatHours" class="input-text"></v-text-field>
                            </td>
                            <td>
                                <span v-if="!isEditable(3)||disabledInputText">{{getChargesHours('Task',props.item, 3)}}</span>
                                <v-text-field v-else v-model="getHoursModel(props.item).day3" type="number" @blur="formatHours" class="input-text"></v-text-field>
                            </td>
                            <td>
                                <span v-if="!isEditable(4)||disabledInputText">{{getChargesHours('Task',props.item, 4)}}</span>
                                <v-text-field v-else v-model="getHoursModel(props.item).day4" type="number" @blur="formatHours" class="input-text"></v-text-field>
                            </td>
                            <td>
                                <span v-if="!isEditable(5)||disabledInputText">{{getChargesHours('Task',props.item, 5)}}</span>
                                <v-text-field v-else v-model="getHoursModel(props.item).day5" type="number" @blur="formatHours" class="input-text"></v-text-field>
                            </td>
                            <td>
                                <span v-if="!isEditable(6)||disabledInputText">{{getChargesHours('Task',props.item, 6)}}</span>
                                <v-text-field v-else v-model="getHoursModel(props.item).day6" type="number" @blur="formatHours" class="input-text"></v-text-field>
                            </td>
                            <td>
                                <span v-if="!isEditable(7)||disabledInputText">{{getChargesHours('Task',props.item, 7)}}</span>
                                <v-text-field v-else v-model="getHoursModel(props.item).day7" type="number" @blur="formatHours" class="input-text"></v-text-field>
                            </td>
                            <td>
                                <div style="text-align:right;"><b>{{getLineTotal('Task',props.item.projectTaskId)}}</b></div>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:footer>
                        <tr class="font-weight-bold">
                            <td>Total</td>
                            <td>{{getSubTotal('Task',1)}}</td>
                            <td>{{getSubTotal('Task',2)}}</td>
                            <td>{{getSubTotal('Task',3)}}</td>
                            <td>{{getSubTotal('Task',4)}}</td>
                            <td>{{getSubTotal('Task',5)}}</td>
                            <td>{{getSubTotal('Task',6)}}</td>
                            <td>{{getSubTotal('Task',7)}}</td>
                            <td>
                                <div style="text-align:right;"><b>{{getGrandTotal('Task')}}</b></div>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
            
            <!-- OVERTIME -->
            <v-card v-if="!loading&&overtime.summary.length>0" class="elavation-1" style="margin-top:5px;"> 
               <v-toolbar flat height="35px">
                    <b>OVERTIME</b>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-data-table
                    :headers="tableHeader"
                    :items="overtime.summary"
                    :loading="loading"
                    hide-actions
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr>
                            <td>
                                {{props.item.projectKey}} {{props.item.projectName}} - {{props.item.projectTaskKey}} {{props.item.taskName}}
                            </td>
                            <td>{{getChargesHours('Overtime',props.item, 1)}}</td>
                            <td>{{getChargesHours('Overtime',props.item, 2)}}</td>
                            <td>{{getChargesHours('Overtime',props.item, 3)}}</td>
                            <td>{{getChargesHours('Overtime',props.item, 4)}}</td>
                            <td>{{getChargesHours('Overtime',props.item, 5)}}</td>
                            <td>{{getChargesHours('Overtime',props.item, 6)}}</td>
                            <td>{{getChargesHours('Overtime',props.item, 7)}}</td>
                            <td>
                                <div style="text-align:right;"><b>{{getLineTotal('Overtime',props.item.projectTaskId)}}</b></div>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:footer>
                        <tr class="font-weight-bold">
                            <td>Total</td>
                            <td>{{getSubTotal('Overtime',1)}}</td>
                            <td>{{getSubTotal('Overtime',2)}}</td>
                            <td>{{getSubTotal('Overtime',3)}}</td>
                            <td>{{getSubTotal('Overtime',4)}}</td>
                            <td>{{getSubTotal('Overtime',5)}}</td>
                            <td>{{getSubTotal('Overtime',6)}}</td>
                            <td>{{getSubTotal('Overtime',7)}}</td>
                            <td>
                                <div style="text-align:right;"><b>{{getGrandTotal('Overtime')}}</b></div>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>

            <!-- Comments and Updates -->
            <v-layout row wrap  style="margin-top:5px;">
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" ref="commentsRef" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialogAddProject" width="700" persistent>   
            <add-project ref="addProjectRef" @send="addProjectHandler" :dialogAddProject.sync="dialogAddProject"></add-project>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>

<script>
import projectChargesApi from '@/api/projectcharges'
import commonfn from '@/common/functions'
import cutoffApi from '@/api/cutoff'
import numFormat from '@/common/num_format'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'

export default {     
    name: 'ChargesWeeklyDetails',
    metaInfo: {
        title: 'Charges Weekly Details',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'My Timesheet' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory'),
        'add-project': () => import('@/components/Projects/ProjectTasksList')
    },   
    data () {
        return {
            error: false,
            errorMessage: '',
            loading: false,
            loading_menu: false,
            menu_status: false,
            dialogAddProject: false,
            search: null,
            expand: true,
            user_data: null,
            header_data: null,
            task: null,
            overtime: null,
            selectedWeekNo: null,
            cutoff_dates: null,
            trans_dates: null,
            task_hours: [],
            overtime_hours: [],
        }
    },
    methods: {
        backToPrev() {
            if (this.viewedByOwner)
                this.$router.push('/projects/charges')
            else
                this.$router.push(`/myteam/charges/weekly/${this.selectedFiscalYear}/${this.selectedWeekNo}`)
        },
        formatHours() {
            if (this.task_hours.length>0) {
                this.task_hours.forEach(item => {
                    if (item.day1!=null) {
                        if (parseFloat(item.day1)>0) {
                            if (parseFloat(item.day1)>24) item.day1=numFormat.formatNumber(24)
                            if (parseFloat(item.day1)<0) item.day1=null
                            item.day1=numFormat.formatNumber(item.day1)
                        } else item.day1=null //remove non numeric input
                    }
                    if (item.day2!=null) {
                        if (parseFloat(item.day2)>0) {
                            if (parseFloat(item.day2)>24) item.day2=numFormat.formatNumber(24)
                            if (parseFloat(item.day2)<0) item.day2=null
                            item.day2=numFormat.formatNumber(item.day2)
                        } else item.day2=null
                    }
                    if (item.day3!=null) {
                        if (parseFloat(item.day3)>0) {
                            if (parseFloat(item.day3)>24) item.day3=numFormat.formatNumber(24)
                            if (parseFloat(item.day3)<0) item.day3=null
                            item.day3=numFormat.formatNumber(item.day3)
                        } else item.day3=null
                    }
                    if (item.day4!=null) {
                        if (parseFloat(item.day4)>0) {
                            if (parseFloat(item.day4)>24) item.day4=numFormat.formatNumber(24)
                            if (parseFloat(item.day4)<0) item.day4=null
                            item.day4=numFormat.formatNumber(item.day4)
                        } else item.day4=null
                    }
                    if (item.day5!=null) {
                        if (parseFloat(item.day5)>0) {
                            if (parseFloat(item.day5)>24) item.day5=numFormat.formatNumber(24)
                            if (parseFloat(item.day5)<0) item.day5=null
                            item.day5=numFormat.formatNumber(item.day5)
                        } else item.day5=null
                    }
                    if (item.day6!=null) {
                        if (parseFloat(item.day6)>0) {
                            if (parseFloat(item.day6)>24) item.day6=numFormat.formatNumber(24)
                            if (parseFloat(item.day6)<0) item.day6=null
                            item.day6=numFormat.formatNumber(item.day6)
                        } else item.day6=null
                    }
                    if (item.day7!=null) {
                        if (parseFloat(item.day7)>0) {         
                            if (parseFloat(item.day7)>24) item.day7=numFormat.formatNumber(24)
                            if (parseFloat(item.day7)<0) item.day7=null
                            item.day7=numFormat.formatNumber(item.day7)
                        } else item.day7=null
                    }
                })
            }
        },
        getHoursModel(data) {
            return this.task_hours.filter(x => {
                return x.projectTaskId == data.projectTaskId
            })[0]
        },
        getProjectChargesId(projectTaskId,transDate) {
            var matched = this.task.details.filter(x => {
                return x.projectTaskId==projectTaskId && x.transDate==transDate
            })
            if (matched.length) return matched[0].projectChargesId
            else return 0
        },
        getTimeOffId(projectTaskId,transDate){
            var matched = this.task.details.filter(x => {
                return x.projectTaskId==projectTaskId && x.transDate==transDate
            })
            if (matched.length) return matched[0].timeOffId
            else return 0
        },
        getSubTotal(source, day){
            var datasource = null
            if (source=='Task') datasource = this.task_hours
            if (source=='Overtime') datasource = this.overtime_hours
            // if (source=='Timeoff') datasource = this.timeoff_hours

            if (day==1) var matched = datasource.filter(x=>x.day1).map(k=>parseFloat(k.day1))
            if (day==2) var matched = datasource.filter(x=>x.day2).map(k=>parseFloat(k.day2))
            if (day==3) var matched = datasource.filter(x=>x.day3).map(k=>parseFloat(k.day3))
            if (day==4) var matched = datasource.filter(x=>x.day4).map(k=>parseFloat(k.day4))
            if (day==5) var matched = datasource.filter(x=>x.day5).map(k=>parseFloat(k.day5))
            if (day==6) var matched = datasource.filter(x=>x.day6).map(k=>parseFloat(k.day6))
            if (day==7) var matched = datasource.filter(x=>x.day7).map(k=>parseFloat(k.day7))

            if (matched.length>0) return numFormat.formatNumber(matched.reduce((prev,next)=>prev+next))
        },
        getLineTotal(source, projectTaskId) {
            var datasource = null
            if (source=='Task') datasource = this.task_hours
            if (source=='Overtime') datasource = this.overtime_hours
            // if (source=='Timeoff') datasource = this.timeoff_hours

            var data = datasource.filter(x=>x.projectTaskId==projectTaskId)[0]
            var total = (data.day1?parseFloat(data.day1):0) +
                    (data.day2?parseFloat(data.day2):0) +
                    (data.day3?parseFloat(data.day3):0) +
                    (data.day4?parseFloat(data.day4):0) +
                    (data.day5?parseFloat(data.day5):0) +
                    (data.day6?parseFloat(data.day6):0) +
                    (data.day7?parseFloat(data.day7):0) 
            return numFormat.formatNumber(total)
        },
        getGrandTotal(source) {
            var datasource = null
            if (source=='Task') datasource = this.task_hours
            if (source=='Overtime') datasource = this.overtime_hours
            // if (source=='Timeoff') datasource = this.timeoff_hours

            var grandTotal = 0
            datasource.forEach(item=> {
                grandTotal += (item.day1?parseFloat(item.day1):0) +
                    (item.day2?parseFloat(item.day2):0) +
                    (item.day3?parseFloat(item.day3):0) +
                    (item.day4?parseFloat(item.day4):0) +
                    (item.day5?parseFloat(item.day5):0) +
                    (item.day6?parseFloat(item.day6):0) +
                    (item.day7?parseFloat(item.day7):0) 
            })
            return numFormat.formatNumber(grandTotal)
        },
        getSubmitData() {
            // note: don't remove null/0 hours in the payload because it is the trigger to delete the record
            // if user has previously added hours to the record and has decided to remove again
            var data = []
            
            for(var item in this.task_hours) {
                const projectTaskId = this.task_hours[item].projectTaskId
                const isAdminProject = this.task_hours[item].isAdminProject

                var transDate = this.header_data.filter(x => { return x.day==1})[0].transDate
                data.push({
                    projectChargesId: this.getProjectChargesId(projectTaskId,transDate),
                    timeOffId: this.getTimeOffId(projectTaskId,transDate),
                    projectTaskId: projectTaskId,
                    isAdminProject: isAdminProject,
                    transDate: transDate,
                    hours: this.task_hours[item].day1 ? this.task_hours[item].day1 : "0",
                    recurrence: 1,
                    remarks: 'weekly submission'
                })

                transDate = this.header_data.filter(x => { return x.day==2})[0].transDate
                data.push({
                    projectChargesId: this.getProjectChargesId(projectTaskId,transDate),
                    timeOffId: this.getTimeOffId(projectTaskId,transDate),
                    projectTaskId: projectTaskId,
                    isAdminProject: isAdminProject,
                    transDate: transDate,
                    hours: this.task_hours[item].day2 ? this.task_hours[item].day2 : "0",
                    recurrence: 1,
                    remarks: 'weekly submission'
                })

                transDate = this.header_data.filter(x => { return x.day==3})[0].transDate
                data.push({
                    projectChargesId: this.getProjectChargesId(projectTaskId,transDate),
                    timeOffId: this.getTimeOffId(projectTaskId,transDate),
                    projectTaskId: projectTaskId,
                    isAdminProject: isAdminProject,
                    transDate: transDate,
                    hours: this.task_hours[item].day3 ? this.task_hours[item].day3 : "0",
                    recurrence: 1,
                    remarks: 'weekly submission'
                })

                transDate = this.header_data.filter(x => { return x.day==4})[0].transDate
                data.push({
                    projectChargesId: this.getProjectChargesId(projectTaskId,transDate),
                    timeOffId: this.getTimeOffId(projectTaskId,transDate),
                    projectTaskId: projectTaskId,
                    isAdminProject: isAdminProject,
                    transDate: this.header_data.filter(x => { return x.day==4})[0].transDate,
                    hours: this.task_hours[item].day4 ? this.task_hours[item].day4 : "0",
                    recurrence: 1,
                    remarks: 'weekly submission'
                })
                
                transDate = this.header_data.filter(x => { return x.day==5})[0].transDate
                data.push({
                    projectChargesId: this.getProjectChargesId(projectTaskId,transDate),
                    timeOffId: this.getTimeOffId(projectTaskId,transDate),
                    projectTaskId: projectTaskId,
                    isAdminProject: isAdminProject,
                    transDate: transDate,
                    hours: this.task_hours[item].day5 ? this.task_hours[item].day5 : "0",
                    recurrence: 1,
                    remarks: 'weekly submission'
                })

                transDate = this.header_data.filter(x => { return x.day==6})[0].transDate
                data.push({
                    projectChargesId: this.getProjectChargesId(projectTaskId,transDate),
                    timeOffId: this.getTimeOffId(projectTaskId,transDate),
                    projectTaskId: projectTaskId,
                    isAdminProject: isAdminProject,
                    transDate: transDate,
                    hours: this.task_hours[item].day6 ? this.task_hours[item].day6 : "0",
                    recurrence: 1,
                    remarks: 'weekly submission'
                })
                
                transDate = this.header_data.filter(x => { return x.day==7})[0].transDate
                data.push({
                    projectChargesId: this.getProjectChargesId(projectTaskId,transDate),
                    timeOffId: this.getTimeOffId(projectTaskId,transDate),
                    projectTaskId: projectTaskId,
                    isAdminProject: isAdminProject,
                    transDate: transDate,
                    hours: this.task_hours[item].day7 ? this.task_hours[item].day7 : "0",
                    recurrence: 1,
                    remarks: 'weekly submission'
                })
            }
            return data
        },
        async saveAll() {
            try {
                this.loading_menu = true
                const data = this.getSubmitData()
                const response = await projectChargesApi.weeklyBatchSave(data, this.selectedFiscalYear, this.selectedWeekNo, this.selectedUserId)
                if (response && response.status==200) {
                    await this.getProjectCharges(false)
                    await this.$refs.updateHistoryRef.getHistory() //need to invoke this due to weekly paging
                }
                this.loading_menu = false
            }catch(error){
                this.errorMessage = error
                this.error = true
            }
        },
        async submitAll() {
            try {
                this.loading_menu = true
                
                //make sure any changes are saved before updating to for review
                const saveData = this.getSubmitData()
                const responseSave = await projectChargesApi.weeklyBatchSave(saveData, this.selectedFiscalYear, this.selectedWeekNo, this.selectedUserId)
                if (responseSave && responseSave.status==200) {
                    await this.getProjectCharges(false)
                }

                const forReviewData = this.getSubmitData()
                const response = await projectChargesApi.weeklyBatchForReview(forReviewData, this.selectedFiscalYear, this.selectedWeekNo, this.selectedUserId)
                if (response && response.status==200) {
                    await this.getProjectCharges(false)
                }
                await this.$refs.updateHistoryRef.getHistory() //need to invoke this due to weekly paging

                this.loading_menu = false
            }catch(error){
                this.errorMessage = error
                this.error = true
            }
        },
        async approveAll() {
            try {
                this.loading_menu = true
                const data = this.getSubmitData()
                const response = await projectChargesApi.weeklyBatchApprove(data, this.selectedFiscalYear, this.selectedWeekNo, this.selectedUserId)
                if (response && response.status==200) {
                    await this.getProjectCharges(false)
                    await this.$refs.updateHistoryRef.getHistory() //need to invoke this due to weekly paging
                }
                this.loading_menu = false
            }catch(error){
                this.errorMessage = error
                this.error = true
            }
        },
        async rejectAll() {
            try {
                this.loading_menu = true
                const data = this.getSubmitData()
                const response = await projectChargesApi.weeklyBatchReject(data, this.selectedFiscalYear, this.selectedWeekNo, this.selectedUserId)
                if (response && response.status==200) {
                    await this.getProjectCharges(false)
                    await this.$refs.updateHistoryRef.getHistory()
                }

                this.loading_menu = false
            }catch(error){
                this.errorMessage = error
                this.error = true
            }
        },
        showAddProject() {
            this.$refs.addProjectRef.getProjects()
            this.dialogAddProject = true
        },
        addProjectHandler(data) {
            var exist = this.task.summary.filter(x => {
                return x.projectId==data.projectId && 
                        x.projectTaskId==data.projectTaskId && 
                        x.projectTaskKey==data.projectTaskKey
            }).length > 0

            if (!exist) {
                this.task.summary.push(data)
                this.task_hours.push({projectTaskId:data.projectTaskId, isAdminProject:data.isAdminProject, day1:null, day2:null, day3:null, day4:null, day5:null, day6:null, day7:null})
            }
        },
        async viewPrevious() {
            this.selectedWeekNo--
            if (this.viewedByOwner) 
                this.$router.push(`/projects/charges/weekly/${this.selectedFiscalYear}/${this.selectedWeekNo}`)
            else
                this.$router.push(`/projects/myteam/charges/weekly/${this.selectedFiscalYear}/${this.selectedWeekNo}/${this.selectedUserId}`)
            
            await this.getProjectCharges(false)

            // the following code are required only if navigating to data where components are not recreated
            // example: navigating to different date transactions using the same page/components
            this.$refs.updateHistoryRef.getHistory()
            this.$refs.commentsRef.invokeSubscribe()
            this.$refs.commentsRef.getCommentsHistory()
        },
        async viewNext() {
            this.selectedWeekNo++
            if (this.viewedByOwner) 
                this.$router.push(`/projects/charges/weekly/${this.selectedFiscalYear}/${this.selectedWeekNo}`)
            else
                this.$router.push(`/projects/myteam/charges/weekly/${this.selectedFiscalYear}/${this.selectedWeekNo}/${this.selectedUserId}`)
            
            await this.getProjectCharges(false)

            // the following code are required only if navigating to data where components are not recreated
            // example: navigating to different date transactions using the same page/components
            this.$refs.updateHistoryRef.getHistory()
            this.$refs.commentsRef.invokeSubscribe()
            this.$refs.commentsRef.getCommentsHistory()
        },
        getChargesHours(source, data, day) {
            var datasource = null
            if (source=='Task') datasource = this.task.details
            if (source=='Overtime') datasource = this.overtime.details
            // if (source=='Timeoff') datasource = this.timeoff.details

            var transDate = this.header_data.filter(x => {return x.day==day})[0].transDate
            var selected = datasource.filter(x => {
                return x.transDate==transDate && x.projectTaskId==data.projectTaskId
            })
            if (selected.length>0) 
                return numFormat.formatNumber(selected[0].hours)
        },
        isEditable(day) {
            var transDate = this.header_data.filter(x => {return x.day==day})[0].transDate
            var selected = this.trans_dates.filter(x => {
                return x.transDate==transDate
            })
            if (selected.length>0) 
                return selected[0].isEditable
        },
        async getProjectCharges(show_loading) {
            try {
                this.loading = show_loading
                var data = {
                    fiscalYear: this.selectedFiscalYear,
                    weekNo: this.selectedWeekNo,
                    userId: this.selectedUserId
                }
                var response = null
                if (this.viewedByOwner)
                    response = await projectChargesApi.getWeeklyDetails(data)
                else
                    response = await projectChargesApi.getWeeklyDetailsByUser(data)

                if (response && response.status==200) {
                    this.user_data = response.data.user
                    this.header_data = response.data.header
                    this.trans_dates = response.data.transDates
                    this.task = response.data.task
                    this.overtime = response.data.overtime
                }
                this.populateHoursList(this.task.details)
                this.formatHours()
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getCutoffSettings(show_loading) {
            try {
                this.loading = show_loading
                const response = await cutoffApi.getByCompany()
                if (response && response.status==200) {
                    this.cutoff_dates = response.data.items.filter(x => {
                        return x.fiscalYear == this.selectedFiscalYear
                    })
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        getTransDateHour(source, projectTaskId,day){
            var datasource = null
            if (source=='Task') datasource = this.task.details
            if (source=='Overtime') datasource = this.overtime.details
            // if (source=='Timeoff') datasource = this.timeoff.details

            var transDate = this.header_data.filter(x => { return x.day==day})[0].transDate
            var matched = datasource.filter(x => {
                return x.transDate==transDate && x.projectTaskId==projectTaskId
            })
            if (matched.length>0) {
                const totalHours = matched.map(x => x.hours).reduce((prev,next) => prev+next)
                return numFormat.formatNumber(totalHours)
            }
        },  
        populateHoursList() {
            this.task_hours = []
            this.overtime_hours = []
            
            if (this.task.summary.length>0) {
                this.task.summary.forEach(item => {
                    this.task_hours.push({
                                            projectTaskId: item.projectTaskId, 
                                            isAdminProject: item.isAdminProject,
                                            day1: this.getTransDateHour('Task',item.projectTaskId,1), 
                                            day2: this.getTransDateHour('Task',item.projectTaskId,2),
                                            day3: this.getTransDateHour('Task',item.projectTaskId,3), 
                                            day4: this.getTransDateHour('Task',item.projectTaskId,4), 
                                            day5: this.getTransDateHour('Task',item.projectTaskId,5), 
                                            day6: this.getTransDateHour('Task',item.projectTaskId,6), 
                                            day7: this.getTransDateHour('Task',item.projectTaskId,7)
                                        })
                })
            }

            if (this.overtime.summary.length>0) {
                this.overtime.summary.forEach(item => {
                    this.overtime_hours.push({
                                            projectTaskId:item.projectTaskId, 
                                            isAdminProject: item.isAdminProject,
                                            day1:this.getTransDateHour('Overtime',item.projectTaskId,1), 
                                            day2:this.getTransDateHour('Overtime',item.projectTaskId,2),
                                            day3:this.getTransDateHour('Overtime',item.projectTaskId,3), 
                                            day4:this.getTransDateHour('Overtime',item.projectTaskId,4), 
                                            day5:this.getTransDateHour('Overtime',item.projectTaskId,5), 
                                            day6:this.getTransDateHour('Overtime',item.projectTaskId,6), 
                                            day7:this.getTransDateHour('Overtime',item.projectTaskId,7)
                                        })
                })
            }
        },
        async updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (!data.includes(this.$store.state.userId)) {
                await this.getProjectCharges(false)
            }

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    async created() {
        this.commonfn = commonfn
        this.numFormat = numFormat

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: this.viewedByOwner? 'My Project Charges Details' : 'Project Charges Details'
        })

        this.selectedWeekNo = this.$route.params.weekNo
        await this.getProjectCharges(true)
        await this.getCutoffSettings(true)
    },
    computed: {
        hasEditRights() {
            return commonfn.hasEditRights(this.$router.currentRoute.path)
        },
        hasApproverRights() {
            return commonfn.hasApproverRights(this.$router.currentRoute.path)
        },
        hasEditAndApprover() {
            return this.hasEditRights && this.hasApproverRights
        },
        pageQueryId() {
            return `chargesweekly-${this.selectedFiscalYear}-${this.selectedWeekNo}-${this.selectedUserId}`
        },
        pageLink() {
            return this.viewedByOwner? `${this.$router.currentRoute.path.replace('/projects/','/projects/myteam/')}${this.selectedUserId}`  : this.$router.currentRoute.path.replace('/projects/myteam/','/projects/').replace(this.selectedUserId, '')
        },
        commentsData() {
            if (!this.loading) {
                return {
                    pageQueryId: this.pageQueryId,
                    pageItemCreatedBy: this.user_data.userId,
                    pageLink: this.pageLink,
                    pageKey: pageKeys.projectcharges_approver,
                    notificationTypeId: notificationTypes.charges_details
                }
            }
        },
        selectedFiscalYear() {
            return this.$route.params.fiscalYear
        },
        selectedUserId() {
            if (this.$route.params.userId) return this.$route.params.userId
            else return this.$store.state.userId
        },
        viewedByOwner() {
            return this.$store.state.userId == this.selectedUserId
        },
        disablePrev() {
            return this.selectedWeekNo==1
        },
        disableNext() {
            if (!this.loading && this.cutoff_dates!=null)
                return this.$moment(this.weekCoverageDesc.to) >= this.$moment(this.cutoff_dates[0].cutoffEnd) 
        },
        weekCoverageDesc() {
            if (!this.loading)
                return {
                    from: this.$moment(this.header_data[0].transDate).format('MMM DD, YYYY'),
                    to: this.$moment(this.header_data[this.header_data.length-1].transDate).format('MMM DD, YYYY')
                }
        },
        lockedPeriod() {
            if (!this.loading)
                return this.trans_dates.filter(x => {
                    return x.isEditable==1
                }).length==0
        },
        noData() {
            if (!this.loading)
                return this.task.details==null || this.task.details.length==0
        },
        approvedAllStatus() {
            if (!this.loading) {
                var approved = this.task.details.filter(item =>{
                    return item.status == commonfn.getStatusCode('Approved')
                }).length
                return (approved > 0 && this.task.details.length == approved)
            }
        },
        rejectedAllStatus() {
            if (!this.loading) {
                var rejected = this.task.details.filter(item =>{
                    return item.status == commonfn.getStatusCode('Rejected')
                }).length
                return (rejected > 0 && this.task.details.length == rejected)
            }
        },
        createdAllStatus() {
            if (!this.loading) {
                var created = this.task.details.filter(item =>{
                    return item.status == commonfn.getStatusCode('Created')
                }).length
                return (created > 0 && this.task.details.length == created)
            }
        },
        forReviewAllStatus() {
            if (!this.loading) {
                var forReview = this.task.details.filter(item =>{
                    return item.status == commonfn.getStatusCode('For Review')
                }).length
                return (forReview > 0 && this.task.details.length == forReview)
            }
        },
        hasForReview() {
            if (!this.loading) {
                var forReview = this.task.details.filter(item =>{
                    return item.status == commonfn.getStatusCode('For Review')
                }).length
                return (forReview > 0 && this.task.details.length > forReview)
            }
        },
        hasCreatedStatus() {
            if (!this.loading) {
                var created = this.task.details.filter(item =>{
                    return item.status == commonfn.getStatusCode('Created')
                }).length
                return (created > 0 && this.task.details.length > created)
            }
        },
        partiallyApprovedStatus() {
            if (!this.loading) {
                var approved = this.task.details.filter(item =>{
                    return item.status == commonfn.getStatusCode('Approved')
                }).length
                return (approved > 0 && this.task.details.length > approved)
            }
        },
        disableForOwner() {
            return this.hasEditRights&&(this.lockedPeriod||this.approvedAllStatus||this.forReviewAllStatus)
        },
        disabledForApprover() {
            return this.hasApproverRights&&(this.lockedPeriod||this.createdAllStatus||this.hasCreatedStatus||this.noData)
        },
        disabledForEditAndApprover(){
            return this.hasEditAndApprover&&this.lockedPeriod
        },
        disabledInputText() {
            return this.approvedAllStatus||this.forReviewAllStatus||(this.rejectedAllStatus&&this.hasApproverRights&&!this.hasEditAndApprover)
        },
        hasHoursEntered() {
            if (this.task_hours.length == 0) return false
            var data = this.task_hours.filter(x => {
                return (x.day1!=null && parseFloat(x.day1)>0) || 
                        (x.day2!=null && parseFloat(x.day2)>0) ||
                        (x.day3!=null && parseFloat(x.day3)>0) ||
                        (x.day4!=null && parseFloat(x.day4)>0) ||
                        (x.day5!=null && parseFloat(x.day5)>0) ||
                        (x.day6!=null && parseFloat(x.day6)>0) ||
                        (x.day7!=null && parseFloat(x.day7)>0)
            })
            return data.length>0
        },
        hasOvertime() {
            return this.overtime_details!=null && this.overtime_details.length>0
        },
        tableHeader(){
            var headerData = []
            headerData.push(
                {text: 'Project - Task', align:'left', value:'', width:'45%', sortable:false},
            )
            this.header_data.forEach(item => {
                headerData.push(
                    {text: this.$moment(item.transDate).format('ddd DD'), align:'left', value: '', width:'', sortable:false},
                )
            })
            headerData.push(
                {text: 'Total', align:'right', value:'', width:'', sortable:false},
            )
            return headerData
        }   
    }
}
</script>
<style scoped>
.input-text {
    width:45px;
    margin:0px 0px -15px 0px;
    font-size: 12px;
}
</style>